.fancyRadioGroupInput {
  .label {
    height: unset;
  }
  .groupContainer {
    //padding-bottom: var(--ixf-space-2);
  }

  .leadingIcon {
    display: flex;
    flex-shrink: 0;
    padding-top: var(--ixf-space-1);

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .optionCopy {
    flex: 1;
    min-width: 0;
  }
}
